import { jwtDecode } from "jwt-decode";

export const AIPIM_INCORP_CLIENT_ID = 13;

const getStoredToken = () =>
  localStorage.getItem("jwtToken") ||
  localStorage.getItem("authToken") ||
  sessionStorage.getItem("token");

const normalizeToken = (token) => (token?.startsWith("Bearer ") ? token.slice(7) : token);

export const getCurrentClientId = () => {
  try {
    const token = normalizeToken(getStoredToken());
    if (token) {
      const decoded = jwtDecode(token);
      const clientId =
        decoded?.id_cliente ??
        decoded?.idCliente ??
        decoded?.idClienteAipim ??
        decoded?.cliente_id;

      if (clientId != null) return Number(clientId);
    }
  } catch (error) {
    // fall back to selectedCompany
  }

  try {
    const selectedCompany = JSON.parse(localStorage.getItem("selectedCompany") || "null");
    const selectedCompanyId =
      selectedCompany?.id ??
      selectedCompany?.idCliente ??
      selectedCompany?.id_cliente ??
      selectedCompany?.idClienteAipim;

    if (selectedCompanyId != null) return Number(selectedCompanyId);
  } catch (error) {
    // ignore invalid localStorage data
  }

  return null;
};

export const canAccessAipimIncorp = () => getCurrentClientId() === AIPIM_INCORP_CLIENT_ID;
